module.exports = __webpack_public_path__ + "static/media/automationIcon.c9bf3c3f.svg";